export const formatNumberWithCommas = (number: number | undefined): string => {
  if (number === undefined || number === null) {
    return '';
  }

  return Intl.NumberFormat('en-US').format(number);
};
